import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { PasswordResetForm } from '../../components/passwordreset';
import {
  isCheckingPrivilege,
  isAllowedToChangePassword,
  getPasswordResetActionResponse,
} from './../../selectors/PasswordReset';
import { passwordReset, grantPasswordResetPrivilege } from './../../actions/PasswordReset';
import { clearActionResponse } from './../../actions/Global';

class PasswordReset extends React.Component {
  /**
   * Getting id and token params when transfered from mail to this url.
   */
  componentDidMount() {
    const { _id, _jwt } = this.props.match.params;
    this.props.grantPasswordResetPrivilege({ _id, _jwt });
  }

  render() {
    const { _id } = this.props.match.params;
    return (
      <Row type={'flex'} align={'middle'}>
        <Col span={24}>
          <PasswordResetForm
            passwordReset={this.props.passwordReset}
            id={_id}
            privilegeCheckLoading={this.props.privilegeCheckLoading}
            hasPasswordChangePrivilege={this.props.hasPasswordChangePrivilege}
            actionResponse={this.props.passwordResetActionResponse}
            clearActionResponse={this.props.clearActionResponse}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{privilegeCheckLoading, hasPasswordChangePrivilege, passwordResetActionResponse}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    privilegeCheckLoading: isCheckingPrivilege(state),
    hasPasswordChangePrivilege: isAllowedToChangePassword(state),
    passwordResetActionResponse: getPasswordResetActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{grantPasswordResetPrivilege: grantPasswordResetPrivilege, passwordReset: passwordReset}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      grantPasswordResetPrivilege: grantPasswordResetPrivilege,
      passwordReset: passwordReset,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{privilegeCheckLoading: shim, hasPasswordChangePrivilege: shim, passwordResetActionResponse: shim,
 * grantPasswordResetPrivilege: shim, passwordReset: shim, clearActionResponse: shim}}
 */
PasswordReset.propTypes = {
  privilegeCheckLoading: PropTypes.bool,
  hasPasswordChangePrivilege: PropTypes.bool,
  passwordResetActionResponse: PropTypes.instanceOf(Map),
  grantPasswordResetPrivilege: PropTypes.func,
  passwordReset: PropTypes.func,
  clearActionResponse: PropTypes.func,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));
